import { Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
    ProtectedRoute,
    EmailOrPhoneAuth,
    ResetPassword,
    AuthContainer,
    EmailResetInstructions,
    MagicLinkController,
    PhoneVerifyFlow,
    InvitationRoutes,
    ProductInvitationRoutes,
    AccountProvider,
} from '@lendica/auth';
import { splitConfig, getUserKey, LeadDataProvider } from '@lendica/application-form';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { AppContainer } from './AppContainer';
import { NoApproval } from './views/NoApproval';
import { SignupFlow } from './views/SignupFlow';
import { SignupCreatePasswordView } from './views/SignupCreatePasswordView';

// const PhoneAuthContainer = () => {
//     const navigate = useNavigate();
//     const { storePortedTokens } = useAccountContext();
//     return (
//         <PhoneAuth
//             baseURL={baseURL}
//             onSuccess={async tokens => {
//                 await storePortedTokens(tokens);
//                 setTimeout(() => {
//                     navigate('/wallet');
//                 }, 100);
//             }}
//             heading="Lendica Portal"
//             body="Use your phone number to sign in 🔐."
//         />
//     );
// };

const DashboardRoutes = () => {
    const navigate = useNavigate();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Routes>
                <Route element={<ProtectedRoute redirectPath="/auth" />}>
                    <Route path="*" element={<AppContainer />} />
                </Route>
                <Route path="/auth/*" element={<AuthContainer />}>
                    <Route
                        path="*"
                        element={
                            <EmailOrPhoneAuth
                                onAuthSuccess={() => {
                                    setTimeout(() => {
                                        navigate(`/wallet`);
                                    }, 100);
                                }}
                            />
                        }
                    />
                    <Route path="magic" element={<MagicLinkController />} />
                    <Route path="verify" element={<PhoneVerifyFlow />} />
                    <Route path="invite/*" element={<InvitationRoutes />} />
                    <Route path="product-invite/*" element={<ProductInvitationRoutes />} />
                    <Route
                        path="create-password"
                        element={
                            <ResetPassword
                                heading="Create password"
                                body="Create a password for your account."
                                action="Create password"
                                onSuccess={async () => {
                                    // await logout();
                                    navigate('/');
                                }}
                            />
                        }
                    />
                    <Route path="reset" element={<EmailResetInstructions />} />
                    <Route
                        path="reset-password"
                        element={
                            <ResetPassword
                                onSuccess={() => {
                                    navigate('/');
                                }}
                            />
                        }
                    />
                </Route>
                <Route path="/signup" element={<SignupFlow />} />
                <Route path="/signup/create-password/*" element={<AuthContainer />}>
                    <Route
                        path="*"
                        element={
                            <SignupCreatePasswordView
                                onAuthSuccess={() => {
                                    navigate('/wallet');
                                }}
                            />
                        }
                    />
                </Route>
                <Route path="/no-approval" element={<NoApproval />} />
                <Route path="/login" element={<Navigate to="/auth" replace />} />
            </Routes>
        </LocalizationProvider>
    );
};

export const App = () => {
    // Create Split config with dynamic user key
    const userKey = getUserKey();
    const splitConfigWithUser = {
        ...splitConfig,
        core: {
            ...splitConfig.core,
            key: userKey,
        },
    };

    return (
        <SplitFactoryProvider config={splitConfigWithUser}>
            <AccountProvider
                onAuthSuccess={() => {
                    /* noop – routing handled in child flows */
                }}
                onAccountClear={() => {
                    /* noop */
                }}
            >
                <LeadDataProvider>
                    <DashboardRoutes />
                </LeadDataProvider>
            </AccountProvider>
        </SplitFactoryProvider>
    );
};
